/**
 * 合约webscoket
 *
 * */

import depthMsg_pb from './contractProtoData/depthMsg_pb.js'
import fillsMsg_pb from './contractProtoData/fillsMsg_pb.js'
import tickersMsg_pb from './contractProtoData/tickersMsg_pb.js'
import fundRatesMsg_pb from './contractProtoData/fundRatesMsg_pb.js'
import assetsMsg_pb from './contractProtoData/assetsMsg_pb.js'
import positionMsg_pb from './contractProtoData/positionMsg_pb.js'
import orderMsg_pb from './contractProtoData/orderMsg_pb.js'
import conditionOrderMsg_pb from './contractProtoData/conditionOrderMsg_pb.js'
import candlesMsg_pb from './contractProtoData/candlesMsg_pb.js'
import marketCandlesMsg_pb from './contractProtoData/marketCandlesMsg_pb.js'
import followAssetsMsg_pb from './contractProtoData/followAssetsMsg_pb.js'
import followPositionMsg_pb from './contractProtoData/followPositionMsg_pb.js'
import orderFetchKlineMsg_pb from './contractProtoData/orderFetchKlineMsg_pb'
import positionHistoryMsg_pb from './contractProtoData/positionHistoryMsg_pb.js'

let ws
// let store
let heartbeat
const queue = []
let onRealtimeCallback
//盘口
let depNowTime = new Date().getTime()
//行情列表
let tickerNowTime = new Date().getTime()
//列表缓存
let listCacheArray = []
//ws掉线时间,用于记录当掉线后，下次连接上后的时间差大于4分钟时，通知页面需要请求历史K线
let dropTime

//盘口和深度
const Topic_Perpetual_Depth = 'perpetual.depth'
const Topic_Deliver_Depth = 'deliver.depth'
//实时成交
const Topic_Perpetual_Fills = 'perpetual.fills'
const Topic_Deliver_Fills = 'deliver.fills'
//行情
const Topic_Perpetual_Tickers = 'perpetual.tickers'
const Topic_Deliver_Tickers = 'deliver.tickers'
const Topic_Portal_Tickers = 'portal.tickers'
//单个币对24行情
const Topic_Perpetual_Ticker = 'perpetual.ticker'
const Topic_Deliver_Ticker = 'deliver.ticker'
//币对的资金费率和合理价
const Topic_Perpetual_Fund_Rate = 'perpetual.fund_rate'
const Topic_Deliver_Fund_Rate = 'deliver.fund_rate'
//所有币对的资金费率和合理价
const Topic_Perpetual_Fund_Rates = 'perpetual.fund_rates'
const Topic_Deliver_Fund_Rates = 'deliver.fund_rates'
//K线
const Topic_Perpetual_Candles = 'perpetual.candles'
const Topic_Deliver_Candles = 'deliver.candles'
//用户资产
const Topic_Perpetual_Assets = 'perpetual.assets'
const Topic_Deliver_Assets = 'deliver.assets'
// 用户仓位
const Topic_Perpetual_Position = 'portal.position'
//指示灯
const Topic_Perpetual_Rank = 'perpetual.rank'
const Topic_Deliver_Rank = 'deliver.rank'
//订单（当前委托）
const Topic_Perpetual_Orders = 'portal.orders'
//条件订单（当前委托）
const Topic_Perpetual_Condition_Orders = 'portal.condition_orders'
//推送消息
const Topic_Integration_Push_Message = 'integration.push_message'
//标记、指数k线
const Topic_Perpetual_Mark_Candles = 'perpetual.mark_candles'
const Topic_Deliver_Mark_Candles = 'deliver.mark_candles'
//当前跟单持仓推送
const Topic_Perpetual_Follow_Position = 'perpetual.follow_position'
const Topic_Deliver_Follow_Position = 'deliver.follow_position'
//当前跟单资产
const Topic_Perpetual_Follow_Assets = 'perpetual.follow_assets'
const Topic_Deliver_Follow_Assets = 'deliver.follow_assets'
//当前跟单带单员持仓
const Topic_Perpetual_Follow_Trader_Position = 'perpetual.follow_trader_position'
const Topic_Deliver_Follow_Trader_Position = 'deliver.follow_trader_position'
//k线BS点
const Topic_Order_Fetch_kline = 'perpetual.order_fetch_kline'
const Topic_Deliver_Order_Fetch_kline = 'deliver.order_fetch_kline'
//持仓历史
const Topic_Perpetual_Position_History = 'perpetual.position_history'
const Topic_Deliver_Position_History = 'deliver.position_history'
//标记价格，指数价格 涨跌幅
// const Topic_Perpetual_Mark_Price_Change_Percent = 'perpetual.mark_price_change_percent'
// const Topic_Deliver_Mark_Price_Change_Percent = 'deliver.mark_price_change_percent'

//处理订阅返回数据
const resDataProcess = (data) => {
  //合约模拟盘处理
  // let moduleName = 'contractModule'
  // if(window.location.pathname.indexOf('/simulation/') > -1){
  //   moduleName = 'simulationModule'
  // }
  // let symbol = store.state[moduleName].currentObject.code // todo: 从params参数中读取
  let pd
  switch (`${data.biz}.${data.type}`) {
    case Topic_Perpetual_Depth: //盘口
    case Topic_Deliver_Depth: //盘口
      let curNow = new Date().getTime()
      if (curNow - depNowTime > 50) {
        // if (params.contractCode?.toUpperCase() === data.contractcode.toUpperCase()) {
        pd = depthMsg_pb.DepthPbMsg.deserializeBinary(data.data.value).toObject()
        let depData = {
          asks: [],
          bids: [],
        }
        pd.asksList.forEach((item) => {
          depData.asks.push(item.infoList)
        })
        pd.bidsList.forEach((item) => {
          depData.bids.push(item.infoList)
        })

        return depData
        //盘口
        // store.state.contractModule.subscribeData.latestPriceList = depData
        //深度图
        // store.state.contractModule.subscribeData.depthLatestPriceList = { ...depData }
      }
      depNowTime = curNow
      // }
      break
    case Topic_Perpetual_Fills: //实时成交
    case Topic_Deliver_Fills: //实时成交
      // if (params.contractCode.toUpperCase() === data.contractcode.toUpperCase()) {
      pd = fillsMsg_pb.FillsPbMsg.deserializeBinary(data.data.value).toObject()
      let fillsData = []
      pd.fillsList.forEach((item) => {
        fillsData.push([item.price, item.amount, item.side, item.createddate, item.id])
      })
      // store.state.contractModule.subscribeData.realTimeList = fillsData
      return fillsData
      // }
      break
    case Topic_Perpetual_Ticker: //单个币对24h行情列表
    case Topic_Deliver_Ticker:
      // todo: 确认以下临时注释的逻辑的作用
      // if (store.state.rangeBenchmark !== isCurrentTimeZone(data.granularity)) {
      //   console.log(store.state.rangeBenchmark, data.granularity, '不是当前周期，跳出 switch case')
      //   break;
      // }
      let ticker = tickersMsg_pb.TickersPbMsg.deserializeBinary(data.data.value).toObject()
      let object = {}
      ticker.tickersList.forEach((item) => {
        item.contractCode = item.contractcode
        // if (item.contractcode.toUpperCase() === params.contractCode.toUpperCase()) {
        object = item
        // }
      })

      // store.state.contractModule.subscribeData.quotationData = object
      return object
      break
    case Topic_Perpetual_Tickers: //行情列表
    case Topic_Deliver_Tickers:
    case Topic_Portal_Tickers:
      // todo: 后续有功能使用
      // if (store.state.rangeBenchmark !== isCurrentTimeZone(data.granularity)) {
      //   console.log(store.state.rangeBenchmark, data.granularity, '不是当前周期，跳出 switch case')
      //   break;
      // }

      pd = tickersMsg_pb.TickersPbMsg.deserializeBinary(data.data.value).toObject()
      listCacheArray = []

      pd.tickersList.forEach((item) => {
        item.contractCode = item.contractcode
        listCacheArray.push(item)
      })

      return listCacheArray
      break
    case Topic_Perpetual_Fund_Rate: ////币对的资金费率和合理价
    case Topic_Deliver_Fund_Rate:
      let fundData = fundRatesMsg_pb.FundRatesPbMsg.deserializeBinary(data.data.value).toObject()
      return fundData.fundratesList[0]
      break
    case Topic_Perpetual_Fund_Rates: //所有币对的资金费率和标记价
    case Topic_Deliver_Fund_Rates:
      const res = fundRatesMsg_pb.FundRatesPbMsg.deserializeBinary(data.data.value).toObject()
      return (
        res?.fundratesList.map((v) => ({
          ...v,
          contractCode: v.contractcode,
        })) || []
      )
      break
    case Topic_Perpetual_Assets: //用户资产
    case Topic_Deliver_Assets:
      let assetsData = assetsMsg_pb.AssetsPbMsg.deserializeBinary(data.data.value).toObject()
      assetsData.brokerId = assetsData.brokerid
      assetsData.userId = assetsData.userid
      return assetsData
      // assetsData.dataList.forEach((item) => {
      //   item.availableBalance = item.availablebalance
      //   item.realAvailableBalance = item.realavailablebalance
      //   item.currencyCode = item.currencycode
      //   item.positionAccountRights = item.positionaccountrights
      //   item.unRealizedSurplus = item.unrealizedsurplus
      //   item.realizedSurplus = item.realizedsurplus
      //   item.positionMargin = item.positionmargin
      //   item.orderMargin = item.ordermargin
      //   item.frozenBalance = item.frozenbalance
      //   item.openMargin = item.openmargin
      //   item.followRealizedSurplus = item.followrealizedsurplus
      //   item.followUnRealizedSurplus = item.followunrealizedsurplus
      //   item.donationOpenMargin = item.donationopenmargin
      //   item.donationMaintenanceMargin = item.donationmaintenancemargin
      //   item.donationFee = item.donationfee
      //   item.donationOrderMargin = item.donationordermargin
      //   item.donationOrderFee = item.donationorderfee
      //   item.donationAccountRights = item.donationaccountrights
      //   item.donationValue = item.donationvalue
      //   item.realAvailableDonation = item.realavailabledonation
      //   item.availableDonation = item.availabledonation
      //   item.donationFrozen = item.donationfrozen
      //   item.donationPositionMargin = item.donationpositionmargin
      //   item.bizType = item.biztype
      // })
      // store.state.contractModule.subscribeData.userAssets = assetsData
      break
    case Topic_Perpetual_Rank: //指示灯。目前没用
    case Topic_Deliver_Rank:
      //store.state.contractModule.subscribeData.rank = data
      break
    case Topic_Perpetual_Position: // 用户持仓
      let positionData = positionMsg_pb.PositionPbMsg.deserializeBinary(data.data.value).toObject()
      positionData.contractCode = positionData.contractcode
      positionData.autoAddMargin = positionData.autoaddmargin
      positionData.availableBalance = positionData.availablebalance
      positionData.closingAmount = positionData.closingamount
      positionData.closingConditionAmount = positionData.closingconditionamount
      positionData.closingLossConditionAmount = positionData.closinglossconditionamount
      positionData.closingProfitConditionAmount = positionData.closingprofitconditionamount
      positionData.createdDate = positionData.createddate
      positionData.indexBase = positionData.indexbase
      positionData.indexBaseDisplayName = positionData.indexbasedisplayname
      positionData.quoteDisplayName = positionData.quotedisplayname
      positionData.baseDisplayName = positionData.basedisplayname
      positionData.maintainRate = positionData.maintainrate
      positionData.maintenanceMargin = positionData.maintenancemargin
      positionData.marginDigit = positionData.margindigit
      positionData.markPrice = positionData.markprice
      positionData.marketPriceDigit = positionData.marketpricedigit
      positionData.maxLever = positionData.maxlever
      positionData.feeRate = positionData.feerate
      positionData.minQuoteDigit = positionData.minquotedigit
      positionData.modifyDate = positionData.modifydate
      positionData.openMargin = positionData.openmargin
      positionData.openMarginRate = positionData.openmarginrate
      positionData.orderAmount = positionData.orderamount
      positionData.realizedSurplus = positionData.realizedsurplus
      positionData.unRealizedSurplus = positionData.unrealizedsurplus
      positionData.unitAmount = positionData.unitamount
      positionData.liqudatePrice = positionData.liqudateprice
      positionData.dealMarket = positionData.dealmarket
      positionData.brokerId = positionData.brokerid
      positionData.userId = positionData.userid
      positionData.selectedMode = positionData.selectedmode
      positionData.latestPrice = positionData.latestprice
      positionData.contractCodeDisplayName = positionData.contractcodedisplayname
      positionData.baseDisplayName = positionData.basedisplayname
      positionData.lastPrice = positionData.lastprice
      positionData.refUserId = positionData.refuserid
      positionData.traderNickname = positionData.tradernickname
      positionData.traderZhNickname = positionData.traderzhnickname
      positionData.traderUid = positionData.traderuid
      positionData.trarderIsNftPhoto = positionData.trarderisnftphoto
      positionData.traderPhoto = positionData.traderphoto
      positionData.contractType = positionData.contracttype
      positionData.bizType = positionData.biztype
      positionData.liquidationDate = positionData.liquidationdate
      positionData.donationOpenMargin = positionData.donationopenmargin
      positionData.donationMaintenanceMargin = positionData.donationmaintenancemargin
      positionData.donationFee = positionData.donationfee
      positionData.donationOrderMargin = positionData.donationordermargin
      positionData.donationOrderFee = positionData.donationorderfee
      positionData.availableDonation = positionData.availabledonation
      positionData.realAvailableDonation = positionData.realavailabledonation
      positionData.shadowAmount = positionData.shadowamount
      positionData.shadowOpenMargin = positionData.shadowopenmargin
      if (positionData.guaranteedstoplossrate) {
        positionData.guaranteedStopLossRate = positionData.guaranteedstoplossrate
      }
      if (positionData.guaranteedstoplossstatus) {
        positionData.guaranteedStopLossStatus = positionData.guaranteedstoplossstatus
      }
      if (positionData.minorderamount) {
        positionData.minOrderAmount = positionData.minorderamount
      }
      if (positionData.maxorderamount) {
        positionData.maxOrderAmount = positionData.maxorderamount
      }
      return positionData
      break
    case Topic_Perpetual_Orders: //订单（当前委托）
      let order = orderMsg_pb.OrderPbMsg.deserializeBinary(data.data.value).toObject()
      // order.contractCode = order.contractcode
      // order.avgPrice = order.avgprice
      // order.createdDate = order.createddate
      // order.dealAmount = order.dealamount
      // order.detailSide = order.detailside
      // order.indexBase = order.indexbase
      // order.indexBaseDisplayName = order.indexbasedisplayname
      // order.quoteDisplayName = order.quotedisplayname
      // order.baseDisplayName = order.basedisplayname
      // order.marginDigit = order.margindigit
      // order.marketPriceDigit = order.marketpricedigit
      // order.modifyDate = order.modifydate
      // order.orderPriceType = order.orderpricetype
      // order.orderSize = order.ordersize
      // order.positionType = order.positiontype
      // order.refConditionOrderId = order.refconditionorderid
      // order.refOrderCondition = order.refordercondition
      // order.stopLimitType = order.stoplimittype
      // order.stopLoss = order.stoploss
      // order.stopProfit = order.stopprofit
      // order.systemType = order.systemtype
      // order.triggerBy = order.triggerby
      // order.triggerDate = order.triggerdate
      // order.triggerPrice = order.triggerprice
      // order.unitAmount = order.unitamount
      // order.reduceOnly = order.reduceonly
      // order.orderType = order.ordertype
      // order.mustMaker = order.mustmaker
      // order.dualPosition = order.dualposition
      // order.dealMarket = order.dealmarket
      // order.brokerId = order.brokerid
      // order.userId = order.userid
      // order.selectedMode = order.selectedmode
      // order.positionId = order.positionid
      // order.latestPrice = order.latestprice
      // order.openMargin = order.openmargin
      // order.liquidatePrice = order.liquidateprice
      // order.orderFee = order.orderfee
      // order.contractType = order.contracttype
      // order.bizType = order.biztype
      // order.liquidationDate = order.liquidationdate
      // order.donationFee = order.donationfee
      // order.donationProfit = order.donationprofit
      // order.orderDonationFee = order.orderdonationfee
      // order.traderNickname = store.state.locale.smallValue == 'zh' ? order.traderzhnickname : order.tradernickname
      // order.tradernickname = store.state.locale.smallValue == 'zh' ? order.traderzhnickname : order.tradernickname
      // store.state.contractModule.subscribeData.perpetualOrders = order
      return order
      break
    case Topic_Perpetual_Condition_Orders: //条件订单（当前委托）
      let conditionOrder = conditionOrderMsg_pb.ConditionOrderPbMsg.deserializeBinary(data.data.value).toObject()

      conditionOrder.contractCode = conditionOrder.contractcode
      conditionOrder.avgPrice = conditionOrder.avgprice
      conditionOrder.createdDate = conditionOrder.createddate
      conditionOrder.contractDirection = conditionOrder.contractdirection
      conditionOrder.dealAmount = conditionOrder.dealamount
      conditionOrder.detailSide = conditionOrder.detailside
      conditionOrder.indexBase = conditionOrder.indexbase
      conditionOrder.indexBaseDisplayName = conditionOrder.indexbasedisplayname
      conditionOrder.quoteDisplayName = conditionOrder.quotedisplayname
      conditionOrder.baseDisplayName = conditionOrder.basedisplayname
      conditionOrder.marginDigit = conditionOrder.margindigit
      conditionOrder.marketPriceDigit = conditionOrder.marketpricedigit
      conditionOrder.modifyDate = conditionOrder.modifydate
      conditionOrder.orderPriceType = conditionOrder.orderpricetype
      conditionOrder.orderSize = conditionOrder.ordersize
      conditionOrder.positionType = conditionOrder.positiontype
      conditionOrder.refConditionOrderId = conditionOrder.refconditionorderid
      conditionOrder.refOrderCondition = conditionOrder.refordercondition
      conditionOrder.stopLimitType = conditionOrder.stoplimittype
      conditionOrder.stopLoss = conditionOrder.stoploss
      conditionOrder.stopProfit = conditionOrder.stopprofit
      conditionOrder.systemType = conditionOrder.systemtype
      conditionOrder.triggerBy = conditionOrder.triggerby
      conditionOrder.triggerDate = conditionOrder.triggerdate
      conditionOrder.triggerPrice = conditionOrder.triggerprice
      conditionOrder.tiggerOrderDetail = conditionOrder.tiggerorderdetailmsg
      conditionOrder.unitAmount = conditionOrder.unitamount
      conditionOrder.reduceOnly = conditionOrder.reduceonly
      conditionOrder.orderType = conditionOrder.ordertype
      conditionOrder.dualPosition = conditionOrder.dualposition
      conditionOrder.mustMaker = conditionOrder.mustmaker
      conditionOrder.dealMarket = conditionOrder.dealmarket
      conditionOrder.brokerId = conditionOrder.brokerid
      conditionOrder.userId = conditionOrder.userid
      conditionOrder.selectedMode = conditionOrder.selectedmode
      conditionOrder.positionId = conditionOrder.positionid
      conditionOrder.mergeId = conditionOrder.mergeid
      conditionOrder.allType = conditionOrder.alltype
      conditionOrder.latestPrice = conditionOrder.latestprice
      conditionOrder.contractType = conditionOrder.contracttype
      conditionOrder.bizType = conditionOrder.biztype
      conditionOrder.liquidationDate = conditionOrder.liquidationdate
      conditionOrder.tracingCallback = conditionOrder.tracingcallback
      conditionOrder.tracingPrice = conditionOrder.tracingprice
      conditionOrder.tracingDirection = conditionOrder.tracingdirection
      conditionOrder.tracingOrderPriceType = conditionOrder.tracingorderpricetype
      conditionOrder.stopLimitType = conditionOrder.stoplimittype
      return conditionOrder
      break
    case Topic_Integration_Push_Message: //推送消息
      return data.data //integrationMsg_pb.IntegrationPbMsg.deserializeBinary(data.data.value).toObject()
    case Topic_Perpetual_Follow_Position: //当前跟单持仓推送
    case Topic_Deliver_Follow_Position:
      let Follow = followPositionMsg_pb.FollowPositionPbMsg.deserializeBinary(data.data.value).toObject()
      Follow.selectedMode = Follow.selectedmode
      Follow.currentpositionsList.forEach((item) => {
        item.contractCodeDisplayName = item.contractcodedisplayname
        item.baseDisplayName = item.basedisplayname
      })
      store.state.contractModule.subscribeData.documentaryCurList = Follow
      break
    case Topic_Perpetual_Follow_Assets: //当前跟单资产
    case Topic_Deliver_Follow_Assets:
      store.state.contractModule.subscribeData.documentaryAssets =
        followAssetsMsg_pb.FollowAssetsPbMsg.deserializeBinary(data.data.value).toObject()
      break
    case Topic_Perpetual_Follow_Trader_Position: //当前带单持仓推送
    case Topic_Deliver_Follow_Trader_Position:
      let obj = positionMsg_pb.PositionPbMsg.deserializeBinary(data.data.value).toObject()
      obj.contractCode = obj.contractcode
      obj.unitAmount = obj.unitamount
      obj.marginDigit = obj.margindigit
      obj.unRealizedSurplus = obj.unrealizedsurplus
      obj.realizedSurplus = obj.realizedsurplus
      obj.lastPrice = obj.lastprice
      obj.markPrice = obj.markprice
      obj.liqudatePrice = obj.liqudateprice
      obj.openMargin = obj.openmargin
      obj.indexBase = obj.indexbase
      obj.contractCodeDisplayName = obj.contractcodedisplayname
      obj.baseDisplayName = obj.basedisplayname
      obj.selectedMode = obj.selectedmode
      store.state.contractModule.subscribeData.orderBearer = obj
      break
    case Topic_Perpetual_Candles: //K线
    case Topic_Deliver_Candles:
      // todo: 确认 && store.state[moduleName].KLinePriceMode === '1' 的逻辑
      // if (params.contractCode?.toUpperCase() === data.contractcode.toUpperCase() && store.state[moduleName].KLinePriceMode === '1') {
      // if (params.contractCode?.toUpperCase() === data.contractcode.toUpperCase()) {
      //判断当前选择的时间和推送的时间刻度，解决会多出一条K线问题Bug. 从1-5-15分钟刻度选择周，月的时候会把当前推送的添加出一条新的K线
      // if (store.state[moduleName].contractHistoryKline.r == data.granularity) { // todo: 确认这个判断的作用
      if (true) {
        let kline = candlesMsg_pb.CandlesPbMsg.deserializeBinary(data.data.value).toObject()
        //用K线的最新价更新外面的最新价，解决后端推送不及时问题
        //store.state[moduleName].currentObject.price = util.showSpliceDecimal(kline.candlesList[0].close, store.state[moduleName].currentObject.marketPriceDigit)

        kline.candlesList.forEach(
          (item) =>
            onRealtimeCallback &&
            onRealtimeCallback({
              time: Number(item.createdate),
              low: Number(item.low),
              high: Number(item.high),
              open: Number(item.open),
              close: Number(item.close),
              // volume: Number(contractUnit(item.amount)), // todo: 该技术逻辑需要在业务逻辑中处理
              volume: Number(item.amount),
              granularity: data.granularity, // 解决会多出一条K线问题Bug
            })
        )
        return kline.candlesList.map((item) => {
          return {
            time: Number(item.createdate),
            low: Number(item.low),
            high: Number(item.high),
            open: Number(item.open),
            close: Number(item.close),
            // volume: Number(contractUnit(item.amount)),  // todo: 该技术逻辑需要在业务逻辑中处理
            volume: Number(item.amount),
            granularity: data.granularity,
          }
        })
      }
      // }
      break
    case Topic_Perpetual_Mark_Candles: //标记，指数 k线
    case Topic_Deliver_Mark_Candles:
      // if (symbol?.toUpperCase() === data.contractcode.toUpperCase() && store.state[moduleName].KLinePriceMode !== '1') {
      //判断当前选择的时间和推送的时间刻度，解决会多出一条K线问题Bug. 从1-5-15分钟刻度选择周，月的时候会把当前推送的添加出一条新的K线
      // if (store.state[moduleName].contractHistoryKline.r == data.granularity) {
      if (true) {
        let kline = marketCandlesMsg_pb.MarketCandlesPbMsg.deserializeBinary(data.data.value).toObject()
        //granularity 必须添加否则推送数据不会更新到k线
        return kline.candlesList.map((item) => {
          return { ...item, granularity: data.granularity }
        })
        // const con = store.state[moduleName].KLinePriceMode === '2' // todo: 该逻辑需要在业务逻辑中处理
        // const con = true
        // kline.candlesList.forEach(
        //   (item) =>
        //     onRealtimeCallback &&
        //     onRealtimeCallback({
        //       time: Number(item.createdate),
        //       low: Number(item[con ? 'marklow' : 'indexlow']),
        //       high: Number(item[con ? 'markhigh' : 'indexhigh']),
        //       open: Number(item[con ? 'markopen' : 'indexopen']),
        //       close: Number(item[con ? 'markclose' : 'indexclose']),
        //       volume: 0,
        //     })
        // )
        // return kline.candlesList.map((item) => {
        //   return {
        //     time: Number(item.createdate),
        //     low: Number(item[con ? 'marklow' : 'indexlow']),
        //     high: Number(item[con ? 'markhigh' : 'indexhigh']),
        //     open: Number(item[con ? 'markopen' : 'indexopen']),
        //     close: Number(item[con ? 'markclose' : 'indexclose']),
        //     volume: 0,
        //   }
        // })
      }
      // }
      break
    case Topic_Order_Fetch_kline: //k线bs
    case Topic_Deliver_Order_Fetch_kline:
      // console.log('Topic_Deliver_Order_Fetch_kline', data, params)
      // const symbol = params.contractCode
      // if (symbol?.toUpperCase() === data.contractcode?.toUpperCase()) {
      // todo: 待确认以下判断的作用
      // if (store.state[moduleName].contractHistoryKline.r == data.granularity) {
      const bsData = orderFetchKlineMsg_pb.OrderFetchKlinePbMsg.deserializeBinary(data.data.value).toObject()

      const order_module = data.env == 0 ? 'contractModule' : 'simulationModule'
      let arr = []
      if (bsData.time && Number(bsData.buyprice) !== 0 && Number(bsData.buynums) !== 0) {
        arr.push({
          direction: 0,
          entrustTime: bsData.time,
          averagePrice: bsData.buyprice,
          entrustLength: bsData.buynums,
        })
      }

      if (bsData.time && Number(bsData.sellprice) !== 0 && Number(bsData.sellnums) !== 0) {
        arr.push({
          direction: 1,
          entrustTime: bsData.time,
          averagePrice: bsData.sellprice,
          entrustLength: bsData.sellnums,
        })
      }

      // todo: 待确认输入更新store的逻辑
      // let klineContractEntrustBS = store.state[order_module].klineContractEntrustBS
      let klineContractEntrustBS = []

      arr.forEach((n) => {
        if (!klineContractEntrustBS.some((v) => v.entrustTime === n.entrustTime && v.direction === n.direction)) {
          klineContractEntrustBS.push(n)
        } else {
          klineContractEntrustBS = klineContractEntrustBS.map((v) => {
            if (v.entrustTime === n.entrustTime && v.direction === n.direction) {
              return n
            } else {
              return v
            }
          })
        }
      })

      klineContractEntrustBS.sort((x, y) => {
        return x.direction - y.direction
      })

      return klineContractEntrustBS
      // }
      // }
      break
    case Topic_Perpetual_Position_History: //仓位历史
    case Topic_Deliver_Position_History:
      let positionHistory = positionHistoryMsg_pb.PositionHistoryPbMsg.deserializeBinary(data.data.value).toObject()
      return positionHistory
    // positionHistory.openPrice = positionHistory.openprice
    // positionHistory.closePrice = positionHistory.closeprice
    // positionHistory.realizedSurplus = positionHistory.realizedsurplus
    // positionHistory.totalAmount = positionHistory.totalamount
    // positionHistory.closeAmount = positionHistory.closeamount
    // positionHistory.openDate = positionHistory.opendate
    // positionHistory.closeAllDate = positionHistory.closealldate
    // positionHistory.contractCode = positionHistory.contractcode
    // positionHistory.detailSide = positionHistory.detailside
    // positionHistory.dualPosition = positionHistory.dualposition
    // positionHistory.dealMarket = positionHistory.dealmarket
    // positionHistory.positionType = positionHistory.positiontype
    // positionHistory.fundRateProfit = positionHistory.fundrateprofit
    // positionHistory.deliveringProfit = positionHistory.deliveringprofit
    // positionHistory.bizType = positionHistory.biztype
    // positionHistory.positionId = positionHistory.positionid
    // positionHistory.contractType = positionHistory.contracttype
    // positionHistory.openMargin = positionHistory.openmargin
    // positionHistory.maxAmount = positionHistory.maxamount
    // positionHistory.donationOpenMargin = positionHistory.donationopenmargin
    // positionHistory.donationFundRateProfit = positionHistory.donationfundrateprofit
    // positionHistory.donationCloseProfit = positionHistory.donationcloseprofit
    // positionHistory.donationFee = positionHistory.donationfee
    // if (positionHistory.currencypair && typeof positionHistory.currencypair != 'undefined') {
    //   positionHistory.currencyPair = positionHistory.currencypair
    //   positionHistory.currencyPair.indexBase = positionHistory.currencypair.indexbase
    //   positionHistory.currencyPair.unitAmount = positionHistory.currencypair.unitamount
    //   positionHistory.currencyPair.marketPriceDigit = positionHistory.currencypair.marketpricedigit
    // }

    // store.state.contractModule.subscribeData.positionHistoryList = positionHistory
    // break
    // case Topic_Perpetual_Mark_Price_Change_Percent:  //标记价格，指数价格 涨跌幅
    // case Topic_Deliver_Mark_Price_Change_Percent:
    //   console.log(data)
    //   if(symbol?.toUpperCase() === data.contractcode.toUpperCase()){
    //     console.log(markPriceChangePercentMsg_pb)
    //     const mark_index_Data = markPriceChangePercentMsg_pb.MarkPriceChangePercentPbMsg.deserializeBinary(data.data.value).toObject()
    //     console.log(mark_index_Data)
    //     // store.state.contractModule.markIndexPercent = mark_index_Data
    //   }
    //   break
  }
}

//区分当前是模拟盘还是实盘
const moduleName = function getModuleName() {
  let moduleName = 'contractModule'
  if (window.location.pathname.indexOf('/simulation/') > -1) {
    moduleName = 'simulationModule'
  }
  return moduleName
}

//获取返回参数中granularity并转化为store中相同与rangeBenchmark的字符，用于比较
const isCurrentTimeZone = (granularity) => {
  if (granularity === '' || granularity === undefined) {
    return ''
  } else {
    if (granularity.indexOf('-') !== -1) {
      return '-' + String(parseInt(granularity.split('-')[1].split(':')[0]))
    } else if (granularity.indexOf('+') !== -1) {
      return String(parseInt(granularity.split('+')[1].split(':')[0]))
    }
  }
}

export default resDataProcess
